<template>
  <div class="plud-wrapper">
    <v-container fluid class="pa-0 fill-height">
      <!-- Contenedor principal -->
      <v-card flat class="plud-container mx-auto">
        <!-- Display de la calculadora (2 primeras filas) -->
        <div class="display-section">
          <div class="display-cell">
            <v-sheet class="display-card elevation-3 pa-3" dark>
              <div class="display-header d-flex justify-space-between">
                <div class="display-label">AMOUNT</div>
                <div class="display-info">QTY: {{ qty }}</div>
              </div>
              <div class="display-value text-h5">
                {{ display || "0.00" }}
              </div>
            </v-sheet>
          </div>
          <div class="display-cell">
            <v-sheet class="display-card elevation-3 pa-3" dark @click="opencart">
              <div class="display-header d-flex justify-space-between">
                <div class="display-label">TOTAL</div>
                <div class="display-info">MODE: {{ mode }}</div>
              </div>
              <div class="display-value">
                <v-btn color="yellow" @click="cartDrawerOpen" text>
                  <span style="font-size: 1.5rem">{{
                    formatCurrency(cartItemTotal) || "0.00"
                  }}</span>
                </v-btn>
              </div>
            </v-sheet>
          </div>
        </div>

        <!-- Grid de botones (10 filas restantes) -->
        <div class="button-grid">
          <!-- Teclado numérico 4x4 -->
          <div class="numeric-keypad">
            <!-- Fila 1: 7, 8, 9, C -->
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(1)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">1</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(2)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">2</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(3)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">3</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleClear"
                color="red lighten-4"
              >
                <span class="text-subtitle-1 font-weight-bold">C</span>
              </v-btn>
            </div>

            <!-- Fila 2: 4, 5, 6, PLU -->
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(4)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">4</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(5)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">5</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(6)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">6</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handlePLU"
                color="teal lighten-3"
              >
                <span class="text-subtitle-1 font-weight-bold">PLU</span>
              </v-btn>
            </div>

            <!-- Fila 3: 1, 2, 3, X -->
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(7)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">7</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(8)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">8</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(9)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">9</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleMultiply"
                color="indigo lighten-4"
              >
                <span class="text-h6 font-weight-bold">X</span>
              </v-btn>
            </div>

            <!-- Fila 4: 0, punto, LST, ENTER -->
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput(0)"
                color="grey lighten-4"
              >
                <span class="text-h6 font-weight-medium">0</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleNumericInput('.')"
                color="grey lighten-3"
              >
                <span class="text-h6 font-weight-bold">.</span>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleLst"
                color="blue-grey lighten-4"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </div>
            <div class="keypad-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-2"
                @click="handleEnter"
                color="green"
                dark
              >
                <span class="text-subtitle-1 font-weight-bold">ENTER</span>
              </v-btn>
            </div>
          </div>

          <!-- Botones de departamento en el resto del grid -->
          <div class="departments-section">
            <div v-for="dept in departments" :key="dept.id" class="dept-cell">
              <v-btn
                tile
                block
                class="grid-btn elevation-1 dept-btn"
                @click="handleDepartment(dept.id)"
                :color="dept.color"
              >
                <div class="dept-content">
                  <span class="text-caption text-wrap">{{ dept.name }}</span>
                  <span class="text-caption text-wrap"
                    >{{ formatDeptId(dept.id) }} / {{ dept.tax }} %</span
                  >
                </div>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { webserver } from "@/services/webserver.js";
export default {
  name: "POSSystem",
  components: {},
  props: {
    cartItemTotal: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data: function () {
    return {
      productslist_dialog: false,
      panel: false,
      display: "",
      toPay: "0.00",
      qty: 1,
      mode: "PRICE", // PRICE, QTY, PLU
      tempDeptNumber: "",
      priceBeforeCode: null,
      products: [],
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    departments: function () {
      // Si no hay productos, devolver un array vacío o placeholder
      if (!this.products || !this.products.length) {
        return [];
      }

      const categories = [];
      const uniqueCategories = [
        ...new Set(
          this.products.map(function (item) {
            return item.categoria;
          })
        ),
      ];

      // Map unique categories to the desired format
      for (let i = 0; i < uniqueCategories.length; i++) {
        const category = uniqueCategories[i];
        // Find the first product with this category to get tax and sku
        const product = this.products.find(function (item) {
          return item.categoria === category;
        });

        if (product) {
          categories.push({
            id: product.sku, // Use sku as id
            name: category, // Use categoria as name
            tax: parseInt(product.tax || 0), // Convert tax to integer, default to 0
          });
        }
      }

      const colors = [
        "cyan lighten-3",
        "pink lighten-3",
        "light-green lighten-3",
        "amber lighten-3",
        "cyan lighten-2",
        "pink lighten-2",
        "light-green lighten-2",
        "amber lighten-2",
        "cyan lighten-1",
        "pink lighten-1",
        "light-green lighten-1",
        "amber lighten-1",
      ];

      // Assign colors to categories
      return categories.map(function (category, index) {
        return {
          id: category.id,
          name: category.name,
          color: colors[index % colors.length],
          tax: category.tax,
        };
      });
    },
  },
  created: function () {},
  mounted: function () {
    console.log("Mounted", window.settings);
    this.get_products();
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy: function () {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    cartDrawerOpen() {
      this.$emit("cart-show", true);
    },
    get_products: function () {
      var self = this;
      self.loading_status = true;
      var qry = {
        store: window.store.store_id,
        table: "items",
      };
      qry.filters = [
        {
          field: "id_pos",
          operator: "=",
          value: window.store.store_id,
        },
        {
          field: "cantidad",
          operator: ">",
          value: 0,
        },
      ];

      webserver("get_table", qry, function (data) {
        //console.log(data);
        self.loading_status = false;
        self.products = data;
      });
    },
    opencart: function () {
      this.$emit("opencart");
    },
    close: function () {
      this.$emit("close", false);
    },
    handleLst: function () {
      this.$emit("products_dialog");
    },
    handleKeyDown: function (event) {
      var elementType = this.getElementType(event.target);
      var ignoredTypes = ["input", "select", "textarea"];

      if (ignoredTypes.includes(elementType)) {
        return;
      }

      var key = event.key;
      console.log("Key pressed:", event);

      if (/^[0-9.]$/.test(key)) {
        this.handleNumericInput(key);
      } else if (key === "Enter") {
        if (event.shiftKey) {
          this.handleShiftEnter();
        } else {
          this.handleEnter();
        }
      } else if (key === "Backspace") {
        this.handleClear();
      } else if (key === "*" || key.toLowerCase() === "x") {
        this.handleMultiply();
      } else if (key === "+") {
        this.handlePlus();
      }
    },

    handleShiftEnter: function () {
      this.$emit("fastPayment", true);
    },

    handlePlus: function () {
      if (this.display && !isNaN(parseFloat(this.display))) {
        this.priceBeforeCode = parseFloat(this.display);
        this.display = "";
        this.mode = "CODE"; // Nuevo modo para esperar código
      }
    },

    handleDeptMode: function () {
      if (this.display && !isNaN(parseFloat(this.display))) {
        this.priceBeforeDept = parseFloat(this.display); // Guardamos el precio
        this.mode = "DEPT";
        this.tempDeptNumber = "";
        this.display = "DEP-";
      }
    },

    handleClear: function () {
      this.display = "";
      this.qty = 1;
      this.mode = "PRICE";
      this.priceBeforeCode = null;
    },

    getElementType: function (target) {
      // Si target es una cadena (como "input#input-229"), extraemos el tipo
      if (typeof target === "string") {
        return target.split("#")[0];
      }
      // Si target es un elemento DOM, usamos su tagName
      if (target instanceof Element) {
        return target.tagName.toLowerCase();
      }
      // Si no podemos determinar el tipo, retornamos una cadena vacía
      return "";
    },
    handleNumericInput: function (value) {
      this.display += value.toString();
    },
    handleMultiply: function () {
      if (this.display) {
        this.qty = parseFloat(this.display) || 1;
        this.display = "";
        this.mode = "QTY";
      }
    },

    handlePLU: function () {
      if (this.display) {
        var pluCode = this.display;
        this.get_product(pluCode);
      }
    },
    async get_product(pluCode) {
      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id.substring(0, 6),
          },
          {
            field: "ean",
            operator: "=",
            value: pluCode,
          },
        ],
      };

      let promise = new Promise(function (resolve, reject) {
        webserver(
          "get_catalog",
          qry,
          function (data) {
            resolve(data);
          },
          function () {
            reject([]);
          }
        );
      });

      var result = await promise;
      if (result.length > 0) {
        result[0].cantidad = this.qty;
        this.$emit("product-selected", result[0]);
        this.handleClear();
      } else {
        this.$emit("product-not-found", pluCode);
      }
    },

    handleDepartment: function (deptId) {
      if (this.display) {
        const price = parseFloat(this.display);
        const dept = this.departments.find(function (d) {
          return d.id === deptId;
        });
        const product = this.createProductByPrice(price, dept);
        this.emitProduct(product);
        this.handleClear();
      }
    },
    handleEnter: function (e) {
      console.log("Enter pressed", this.display, this.mode, this.priceBeforeCode, e);
      if (this.mode === "CODE" && this.display && this.priceBeforeCode !== null) {
        const code = this.display.trim();

        // Si es código de 2 dígitos, es departamento
        if (/^\d{2}$/.test(code)) {
          const deptId = code;
          const dept = this.departments.find(function (d) {
            return d.id === deptId;
          });
          console.log("Department found", deptId, dept);
          if (dept) {
            const product = this.createProductByPrice(this.priceBeforeCode, dept);
            this.emitProduct(product);
          } else {
            this.$emit("product-not-found", code);
          }
        } else {
          // Si no es código de 2 dígitos, buscar PLU
          this.get_product(code);
        }
        this.handleClear();
      } else {
        // Mantener el comportamiento original del Enter para otros casos
        if (this.mode === "PRICE" || this.mode === "QTY") {
          if (this.display) {
            const price = parseFloat(this.display);
            const dept = this.departments[0];
            const product = this.createProductByPrice(price, dept);
            this.emitProduct(product);
            this.handleClear();
          }
        }
      }
    },
    createProductByPrice: function (price, dept) {
      return {
        id_pos: window.store.store_id,
        sku: dept.name + price,
        ean: dept.id + "-" + price,
        categoria: dept.name,
        nombre: dept.name,
        grupo: "",
        marca: dept.name,
        refe: dept.id + "-" + dept.name,
        color: price,
        talla: "",
        cantidad: this.qty,
        costo: "0",
        precio: price,
        precioB: "0",
        precioC: "0",
        descuento: "0",
        store_name: this.$store.state.seller.PartyName,
        category: dept.name,
        groupName: "",
        brand: dept.name,
        colorName: "",
        tax: dept.tax,
      };
    },
    emitProduct: function (product) {
      this.$emit("product-selected", {
        ...product,
        qty: this.qty,
        tItem: product.price * this.qty,
      });
    },
    parseNumber: function (value) {
      if (typeof value === "number") {
        return value;
      }
      if (typeof value === "string") {
        // Eliminar cualquier carácter que no sea dígito o punto
        const cleanedValue = value.replace(/[^\d.]/g, "");
        return parseFloat(cleanedValue);
      }
      return NaN;
    },
    formatCurrency: function (value) {
      try {
        const numValue = this.parseNumber(value);
        if (isNaN(numValue)) {
          console.warn("Invalid input for formatCurrency:", value);
          return "Invalid input";
        }
        // Usar Intl.NumberFormat para un formateo más robusto
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(numValue);
      } catch (error) {
        console.error("Error in formatCurrency:", error);
        return "Error formatting currency";
      }
    },
    formatDeptId: function (id) {
      // Formatear el ID como "01", "02", etc.
      return id.toString().padStart(2, "0");
    },
  },
  watch: {
    panel: function (e) {
      if (e) {
        this.$emit("panel");
      }
    },
  },
};
</script>

<style scoped>
.plud-wrapper {
  width: 100%;
  height: calc(100vh -112px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.plud-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: calc(100vh - 112px); /* Altura total menos appbar */
  background-color: #f9f9f9;
  border-radius: 8px;
}

/* Display ocupa 2 filas de 12 */
.display-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 8px;
  height: calc((100vh - 112px) * 2 / 12); /* 2/12 del espacio disponible */
}

.display-cell {
  position: relative;
  height: 100%;
  min-height: 80px;
}

.display-card {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #2d3748 !important;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.display-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.display-label {
  color: #90caf9;
  font-weight: 500;
  letter-spacing: 1px;
}

.display-info {
  color: #e0e0e0;
  font-size: 0.9rem;
}

.display-value {
  font-size: 1.5rem;
  font-weight: 500;
}

/* Grid para los botones - exactamente 10 filas de 12 */
.button-grid {
  display: flex;
  flex-direction: column;
  height: calc((100vh - 56px) * 10 / 12); /* 10/12 del espacio disponible */
  padding: 8px;
}

/* Teclado numérico 4x4 */
.numeric-keypad {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columnas */
  grid-template-rows: repeat(4, 1fr); /* 4 filas */
  gap: 8px;
  height: calc(100% * 4 / 10); /* 4/10 del espacio de los botones */
  margin-bottom: 8px;
}

.keypad-cell {
  position: relative;
  height: 100%;
  min-height: 40px;
}

/* Sección de departamentos */
.departments-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 columnas */
  grid-template-rows: repeat(6, 1fr); /* 6 filas */
  gap: 8px;
  height: calc(100% * 6 / 10); /* 6/10 del espacio de los botones */
}

.dept-cell {
  position: relative;
  height: 100%;
  min-height: 40px;
}

.grid-btn {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border-radius: 6px !important;
  text-transform: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.2s ease;
}

.grid-btn:hover {
  opacity: 0.9;
}

.grid-btn:active {
  transform: scale(0.97);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) inset;
}

/* Botones de departamento */
.dept-btn {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.dept-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.dept-id {
  font-size: 0.75rem;
  opacity: 0.8;
  background: rgba(0, 0, 0, 0.1);
  padding: 0px 4px;
  border-radius: 4px;
  margin-bottom: 2px;
  font-weight: 500;
}

.text-wrap {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word;
  text-align: center;
  max-height: 2.5em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Estilos responsivos */
@media (max-width: 600px) {
  .display-section {
    min-height: 70px;
  }

  .display-value {
    font-size: 1.25rem;
  }

  .grid-cell {
    min-height: 50px;
  }
}
</style>
